<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <MenuItemsForm :baseMenuItem="prefillMenuItem" @submit-requested="submitRequested"></MenuItemsForm>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MenuItemsForm from './MenuItemsForm.vue'

  export default {
  components: { MenuItemsForm },
  computed: {
    prefillMenuItem() {
      var query = this.$route.query;
      if (query && (query.slug || query.labelPt || query.labelEn)) {
        return {
          url: query.slug ? '/' + query.slug : '',
          labels: {
            pt: query.labelPt || '',
            en: query.labelEn || ''
          },
          position: 0,
          isVisible: true
        };
      }
      return null;
    }
  },
  methods: {
    ...mapActions('menuItems', ['postMenuItem']),
    submitRequested (input) {
      this.postMenuItem(input);
    },
  }
}
</script>

<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style>